module.exports = __webpack_public_path__ + "img/caret-left-fill.618433e8.svg";